import type {
  AuthAuthPermissions,
  AuthRole,
} from '@robovision/rvai-auth'
import { naturalSort } from '@robovision/rvai-utils'


interface MemberRoleParams {
  createdAt: Date
  description: string
  id: string
  name: string
  permissions: AuthAuthPermissions[]
}

const PermissionsOrder: AuthAuthPermissions[] = [
  'PROJECT_CREATION',
  'DATA_UPLOAD',
  'DATA_LABELING',
  'LABELING_REVIEW',
  'MODEL_CREATION',
  'INFERENCE',
  'SYSTEM_MANAGEMENT',
  'EDGE',
]

function sortPermissions (
  a: AuthAuthPermissions,
  b: AuthAuthPermissions,
): number {
  const aIndex = PermissionsOrder.findIndex(p => p === a)
  const bIndex = PermissionsOrder.findIndex(p => p === b)
  // first sort by specific order
  if (aIndex !== -1 && bIndex !== -1) return aIndex < bIndex ? -1 : 1
  // specific order should be on top
  if (aIndex !== -1) return -1
  if (bIndex !== -1) return 1
  // then return by name
  return naturalSort(a, b)
}

export class MemberRole {
  public readonly createdAt: Date
  public readonly description: string
  public readonly id: string
  public readonly name: string
  public readonly permissions: AuthAuthPermissions[]

  public constructor (params: MemberRoleParams) {
    this.createdAt = params.createdAt
    this.description = params.description
    this.id = params.id
    this.name = params.name
    this.permissions = params.permissions
  }

  public static fromResponse (data: AuthRole) {
    return new MemberRole({
      createdAt: new Date(data.createdAt),
      description: data.description ?? '',
      id: data.id,
      name: data.name,
      permissions: data.permissions.map(p => p.id).sort(sortPermissions),
    })
  }
}
